import React, { useEffect, useState } from 'react';
import { Outlet } from 'react-router-dom';

import supabase from '../../../../supabaseClient';
import { useAuth } from '../../../../contexts/authContext';
import { usePermissions } from '../../../../contexts/PermissionsContext';

const AdminLMSLayout = () => {
  const { user } = useAuth();
  const { roles, loading: permLoading } = usePermissions();
  const [pendingEvaluations, setPendingEvaluations] = useState(0);

  // Show loading spinner while permissions are loading
  if (permLoading) return <div>Loading...</div>;

  // Only allow admin role
  const isAdmin = roles && roles.some(r => r.role === 'admin');
  if (!isAdmin) {
    return <div>You do not have permission to access this section.</div>;
    // Or: return <Navigate to="/" replace />;
  }

  useEffect(() => {
    if (isAdmin) {
      supabase.rpc('count_pending_evaluations')
        .then(({ data, error }) => {
          if (error) {
            console.error('Error fetching pending evaluations:', error);
            setPendingEvaluations(0);
          } else {
            setPendingEvaluations(data || 0);
          }
        });
    }
  }, [user, isAdmin]);

  return (
    <div className="lms-layout">
      <main className="lms-main-content" tabIndex={-1}>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLMSLayout;
